import { Button } from "react-bootstrap";
import { IoLogoWhatsapp, IoIosCall } from "react-icons/io";
import "./Floating_Menu.css";

const Floating_Menu = () => {
  const handleCallClick = () => {
    window.open("tel:+919981651000");
  };

  const whatsAppNumber = "9981621000";

  return (
    <div className="floating-menu">
      <div className="menu-items">
        <Button onClick={handleCallClick} className="mb-2 action-btn call-btn">
          <IoIosCall size={28} color="#ffffff" />
        </Button>

        <Button
          href={`https://wa.me/${whatsAppNumber}`}
          target="_blank"
          className="mb-2 action-btn whatsapp-btn"
        >
          <IoLogoWhatsapp size={28} color="#ffffff" />
        </Button>
      </div>
    </div>
  );
};

export default Floating_Menu;
